export default __webpack_public_path__ + "static/media/WATCH-NEW.13d8e547.webp";